import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../config/theme/baseTheme";
import {
  chipContainerStyles,
  orderStatusTagVariants,
  rootSectionWithContainer,
  tagStyles
} from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ...rootSectionWithContainer(theme),
    tabPanelContainer: {
      flexDirection: "row",
      height: "100%",
      "& .panelItem": {
        width: "100%",
        "&.chipFilter": {
          padding: "16px 16px 16px 0px",
          "& .chipsContainer": {
            "& .chipFilterItem": {
              height: 36,
              marginRight: "24px",
              borderRadius: theme.spacing(1),
              border: "1px solid rgba(10, 67, 124, 0.2)",
              backgroundColor: "#FFFFFF",
              cursor: "pointer",
              "&:last-child": {
                marginRight: 0,
              },
              "&.firstItem": {
                boxShadow: `0px 0px 10px 4px ${COLORS.BOX_SHADOW_PRIMARY}`,
                border: `2px solid ${theme.palette.primary.main}`,
              },
              "&.active": {
                background: `linear-gradient(274.11deg, ${COLORS.GRADIENT_BLUE} 2.78%, ${theme.palette.primary.main} 94.36%)`,
                border: "none",
                boxShadow: "none",
                "& .chipItem p": {
                  color: COLORS.WHITE,
                },
              },
              "&.fiveItemsWidth": { minWidth: "18%" },
              "&.fourItemsWidth": { minWidth: "23%" },
              ...chipContainerStyles(theme)
            },
          },
        },
        "&.gridWrapper": {
          height: "calc(100% - 70px)",
          "& .idLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
        },
      },
    },
    statusHeaderContainer: {
      "& .tag": {
        ...tagStyles(theme).base,
        ...orderStatusTagVariants,
        "&.OCEAN_GREEN": {
          color: COLORS.OCEAN_GREEN,
          backgroundColor: COLORS.WHITE,
          border: "solid",
          borderWidth: "1px",
          borderColor: COLORS.OCEAN_GREEN,
        },
        "&.CORAL_PINK": {
          color: COLORS.CORAL_PINK,
          backgroundColor: COLORS.WHITE,
          border: "solid",
          borderWidth: "1px",
          borderColor: COLORS.CORAL_PINK,
        },
        "&.ALERT_ORANGE": {
          color: COLORS.ALERT_ORANGE,
          backgroundColor: COLORS.WHITE,
          border: "solid",
          borderWidth: "1px",
          borderColor: COLORS.ALERT_ORANGE,
        },
        "&.AVATAR_OCEAN": {
          color: COLORS.AVATAR_OCEAN,
          backgroundColor: COLORS.WHITE,
          border: "solid",
          borderWidth: "1px",
          borderColor: COLORS.AVATAR_OCEAN,
        },
        "&.DARK_GOLD_ORANGE": {
          color: COLORS.DARK_GOLD_ORANGE,
          backgroundColor: COLORS.WHITE,
          border: "solid",
          borderWidth: "1px",
          borderColor: COLORS.DARK_GOLD_ORANGE,
        },
      },
    },
    button: {
      margin: theme.spacing(0.5),
      "&:last-child": {
        marginRight: theme.spacing(0),
      },
    },
    colSettings: {
      float: "right",
      marginTop: -3,
    },
    buttonContainer: {
      marginLeft: "auto",
      "& .clearAllFilterBtn": {
        fontSize: 14,
        fontWeight: 600,
        marginRight: theme.spacing(2),
      },
    },
    dashboardTabRootStyle: {
      width: "100%",
      padding: "0px 24px 0px 24px",
      background: COLORS.ALICE_GRAY,
      height: "44px",
      minHeight: "44px",
      fontSize: 16,
      fontWeight: 500,
      color: COLORS.DUSTY_GRAY,
      "& .MuiTabs-indicator": {
        display: "none",
      },
      "& .MuiTabs-flexContainer": {
        height: "44px",
      },
      "& .MuiTab-root.Mui-selected": {
        fontWeight: 600,
        color: COLORS.MINE_SHAFT_NEW,
      },
    },
    dashboardTabPanelRootStyle: {
      width: "100%",
      padding: 0,
    },
  })
);
